module.exports = __webpack_public_path__ + "img/leaf_right_2.3b2766d3.png";